import { Directive, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
    selector: '[cart-icon]',
    host: {
        '(click)': 'onClick()'
    }
})

export class CartIconDirective {
    private cartCount = '';

    constructor(public viewContainer: ViewContainerRef, public _router: Router) {
    }

    onClick() {
        this._router.navigate(['/finance/checkout']);
    }
}
